export default {"src":"/_next/static/image/public/images/ic_location_doctorcard.7b6eeb116581cabf663e7939aa2aaa87.svg","height":21,"width":21};